import { render, staticRenderFns } from "./VariantSifterVariantDotMenu.vue?vue&type=template&id=a0c7deca&scoped=true&"
import script from "./VariantSifterVariantDotMenu.vue?vue&type=script&lang=js&"
export * from "./VariantSifterVariantDotMenu.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterVariantDotMenu.vue?vue&type=style&index=0&id=a0c7deca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c7deca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0c7deca')) {
      api.createRecord('a0c7deca', component.options)
    } else {
      api.reload('a0c7deca', component.options)
    }
    module.hot.accept("./VariantSifterVariantDotMenu.vue?vue&type=template&id=a0c7deca&scoped=true&", function () {
      api.rerender('a0c7deca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterVariantDotMenu.vue"
export default component.exports